module.exports = __webpack_public_path__ + "media/veracruz/uni_aerea-580425f7.png";